export default Object.freeze({
  WHITE: "#ffffff",
  PEERPAL_BLUE: "007aff",
});
